import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { InfoLaboratoryAreaMessageViewModel } from 'app/shared/prothesis-api-view-models/info-laboratory-area-message.view-model';
import { Observable } from 'rxjs/internal/Observable';
import { ConfigurationService } from '../../configuration.service';

@Injectable({
  providedIn: 'root',
})
export class LaboratoryAreaMessageService {
  protected _configurationService = inject(ConfigurationService);
  protected _httpClient = inject(HttpClient);

  protected get _actionUrl(): string {
    return `${this._configurationService.ProthesisApiAddress}${'/LaboratoryAreaMessage/'}`;
  }

  public getInfoLaboratoryAreaMessage(): Observable<InfoLaboratoryAreaMessageViewModel> {
    return this._httpClient.get<InfoLaboratoryAreaMessageViewModel>(this._actionUrl);
  }
}
